<div (click)="bundletDetails(element)">
  <div class="product-card bundle-card" [class.product-card-mobile]="isMobile">

    @if(calcDis(element.pricea, element.price) !== 0){
    <div class="discount-badge">
      {{ calcDis(element.pricea, element.price) }}%
      {{ "discount" | transloco }}
    </div>
    }

    <div class="bundle-badge">
      {{ "deal" | transloco }}
    </div>

    <div class="product-visual">
      <div class="product-circle"></div>
      <div class="product-circle-dots"></div>

      <div class="product-img" [class.product-img-mobile]="isMobile">
        <div #bundleSwiper class="swiper bundle-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" *ngFor="let img of bundleSlides">
              <img [defaultImage]="'/assets/imageloading.gif'" [lazyLoad]="img" [errorImage]="'/assets/noproduct.png'"
                alt="{{ 'deal' | transloco }}" />
            </div>
          </div>

          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>

    <div class="product-info">

      @if(isAr){
      <p class="product-name" [class.product-name-mobile]="isMobile">
        {{ element.name_ar }}
      </p>
      } @else {
      <p class="product-name" [class.product-name-mobile]="isMobile">
        {{ element.name_en }}
      </p>
      }

      <div *ngIf="!showBundleItems; else bundleTemplate" class="bundle-description-wrap">
        @if(isAr){
        <p class="bundle-description">
          {{ element.description_ar }}
        </p>
        } @else {
        <p class="bundle-description">
          {{ element.description_en }}
        </p>
        }
      </div>

      <ng-template #bundleTemplate>
        <div class="bundle-items-premium" *ngIf="element?.items?.length">
          <div class="bundle-chip" *ngFor="let item of element.items">
            <div class="chip-img">
              <img [defaultImage]="'/assets/imageloading.gif'" [lazyLoad]="fixImage(item.stock.image)"
                [errorImage]="'/assets/noproduct.png'" alt="item" />
            </div>

            <div class="chip-body">
              <div class="chip-name">
                {{ isAr ? item.stock.name_ar : item.stock.name_en }}
              </div>
            </div>

            <div class="chip-qty">
              ×{{ item.quantity }}
            </div>
          </div>
        </div>
      </ng-template>

      <div class="price-row">
        <span class="new-price" [class.new-price-mobile]="isMobile">
          {{ element.pricea }} {{ "egpe" | transloco }}
        </span>

        @if(calcDis(element.pricea, element.price) !== 0){
        <span class="old-price">
          {{ element.price }} {{ "egpe" | transloco }}
        </span>
        }
      </div>

      <button class="btn btn-add btn-bundle-toggle btn-bundle-secondary" type="button"
        (click)="toggleBundleItems(); $event.stopPropagation()">
        {{ showBundleItems ? ("Show Description" | transloco) : ("Show Bundle Items" | transloco) }}
      </button>

      <button class="btn btn-add btn-bundle-main" type="button" (click)="addBundle(element); $event.stopPropagation()">
        {{ "addtocart" | transloco }}
      </button>

    </div>
  </div>
</div>